export const defaultThemeColor: string = 'material';

export const themeColors: string[] = [
    'soft-orange',
    'soft-yellow',
    'soft-green',
    'soft-blue',
    'soft-purple',
    'soft-gray',
    'soft-brown'
];
